<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card class="elevation-0">
        <v-card-title class="layout justify-center">
          <h1>Wedding Cakes</h1>
        </v-card-title>
        <v-card-text class="text-xs-center">
          Beautiful wedding cakes made to your own design.
        </v-card-text>
        <v-container grid-list-sm fluid v-if="images.length > 0">
          <v-layout row wrap>
            <v-flex
              v-for="(image, i) in images"
              :key="i"
              xs4
              d-flex
            >
              <v-hover>
              <v-card flat tile class="d-flex" 
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 24 : 0}`" :style="{cursor: hover ? 'pointer' : 'default'}">
                <v-img
                  @click.stop="enlargeImage(i)"
                  :src="image.src"
                  :lazy-src="`https://picsum.photos/10/6?image=1`"
                  aspect-ratio="0.9"
                  class="grey lighten-2"
                >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
        <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
      </v-card>
    </v-flex>
    <gallery :show="gallery" @visible="setGalleryState" :images="images" :index="activeImage"></gallery>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
export default {
  data () {
    return {
      gallery: false,
      activeImage: -1,
      images: []
    }
  },
  mounted () {
    let images = []
    firebase.database().ref('images').orderByChild('type').equalTo('wedding').once('value')
      .then(snap => {
        for (let image in snap.val()) {
          images.push(snap.val()[image])
        }
      })
    this.images = images
  },
  methods: {
    enlargeImage (n) {
      this.activeImage = n
      this.gallery = true
    },
    setGalleryState (val) {
      this.gallery = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Wedding.vue